const uuid = require('uuid');
import React from 'react';
import PropTypes from 'prop-types';

const _ = {
    find:       require('lodash/find'),
    findIndex:  require('lodash/findIndex'),
    filter:     require('lodash/filter'),
    assign:     require('lodash/assign'),
    forEach:    require('lodash/forEach'),
    sortBy:     require('lodash/sortBy'),
    map:        require('lodash/map'),
    clone:      require('lodash/clone'),
    without:    require('lodash/without'),
    isEqual:    require('lodash/isEqual'),
};
import ReactFlow, { ReactFlowProvider, ArrowHeadType, Handle, Position, removeElements, addEdge, useReactFlow, Controls } from 'react-flow-renderer';

import CompletionNode from './CompletionNode';
import SkillNode from './SkillNode';
const AssetUtil = require('../../../util/asset');

// these keys should match the values in ShortCourseConstants.NODE_TYPES
const nodeTypes = {
    'completion': CompletionNode,
    'skill': SkillNode,
};

const arrowHeadType = ArrowHeadType.ArrowClosed; // ArrowHeadType.Arrow; 
const arrowHeadColor = 'black';
 
const propTypes = {
    playStore: PropTypes.object.isRequired, // instance of ShortCoursePlayStore
};
const defaultProps = {};

class ShortCourseProgressMap extends React.Component {
    constructor(props) {
        super(props);
        
        this.playStore = props.playStore;
        this.playActions = props.playStore.getActions();

        let elements = this.createMapElements(props);
        let selected_node_id = this.playStore.getNodeId();
        
        this.state = { 
            elements,
            selected_node_id,
        };
        this.unsubscribes = [this.playStore.getStore().listen(this.onPlayChange)];
    }
    
    componentDidMount() {
        // $(".react-flow__controls-fitview").click(); // fitView hackery
    }
    
    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    onPlayChange=(storeState)=>{
        let selected_node_id = this.playStore.getNodeId();
        this.setState({selected_node_id});
    }
    
    getHandleSortedPrerequisites=(node,doc)=>{
        let preNodes = _.map(node.prereq_node_ids,(node_id)=>(_.find(doc.nodes,{node_id})));
        preNodes = _.filter(preNodes,(elem)=>(!!elem));
        // preNodes = _.sortBy(preNodes,[(sortNode)=>(sortNode.position.y)]); // for horizontally oriented graph
        preNodes = _.sortBy(preNodes,[(sortNode)=>(sortNode.position.x)]);
        return preNodes;
    }
    
    createMapElements=(props)=>{
        const playStore = props.playStore;
        const doc = playStore.getDoc();
        
        var elements = [];
        
        const showEdges = false;
        
        // in case a node position wasn't defined in the doc, we make something up
        function calcDummyPosition(node,node_index) {
            console.log(`Position of node ${node.node_id} missing!`);
            let c = node_index % 16;
            let r = Math.floor(node_index / 16);
            return { x: 100 + c * 50, y: 100 + r * 50 };
        }
        
        if (doc && doc.nodes) {
            _.forEach(doc.nodes,(node,index)=>{
                let preNodes = this.getHandleSortedPrerequisites(node,doc);
                
                if (showEdges) {
                    // add edges to prerequisite nodes
                    _.forEach(preNodes,(sourceNode,pre_index)=>{
                        let edge_id = `e:${sourceNode.node_id}:${node.node_id}`
                        elements.push({
                            id: edge_id,
                            source: sourceNode.node_id,
                            target: node.node_id,
                            targetHandle: `p${pre_index+1}`,
                            type: 'straight',
                            arrowHeadType,
                        });
                    });
                }
                let data = {
                    name: node.name || '',
                    description: node.description || '',
                    numTargetHandles: showEdges ? 0 : preNodes.length,
                    img_src: node.img_src && AssetUtil.resolveAssetPath(node.img_src),

                    // some values that childen need
                    playStore,
                };
                elements.push({
                    id: node.node_id,
                    type: this.playStore.getNodeType(node),
                    position: node.position || calcDummyPosition(index),
                    selectable: true,
                    connectable: false,
                    // targetPosition: 'left', // default is top according to https://reactflow.dev/docs/api/nodes/node-options/
                    // sourcePosition: 'right',
                    data
                });
                
                if (preNodes.length < node.prereq_node_ids.length) {
                    // console.log(`removing invalid prereq(s) from node: ${JSON.stringify({node_id:node.node_id, prereq_node_ids:node.prereq_node_ids})}`);
                    // node.prereq_node_ids = _.map(preNodes,'node_id');
                }
            });
        }
        return elements;
    }
    
    handleSelectNode=(selected_node_id)=>{
        let prerequisitesSatisfied = this.playStore.getArePrerequisitesSatisfied(selected_node_id);
        if (prerequisitesSatisfied) {
            this.playActions.selectNode({node_id:selected_node_id});
        }
    }

    onLoad=(flowInst)=>{
        if (flowInst && flowInst.fitView) {
            setTimeout(()=>{
                flowInst.fitView({padding:1});
            },1);
        }
    }

    render() {
        // Controls API: see https://reactflow.dev/docs/api/plugin-components/controls/
        return (
            <div className="short-course-progress-map">
                <ReactFlowProvider>
                    <ReactFlow ref="flow" nodesConnectable={false} nodesDraggable={false} nodeTypes={nodeTypes} onLoad={this.onLoad}
                        arrowHeadColor={arrowHeadColor}
                        onSelectionChange={(elems)=>{
                            if (elems && (elems.length < 2)) {
                                let elem = elems[0]; // could be undefined (deselect)
                                this.handleSelectNode(elem.id);
                            }
                        }}
                        onPaneClick={()=>{
                            this.handleSelectNode(null); // deselect
                        }}
                        elements={this.state.elements} />
                    <Controls showInteractive={false}/>
                    {/*<button className="fit-view-button" onClick={this.doFitView}>
                        <span className="fa fa-expand"/> 
                    </button>*/}
                </ReactFlowProvider>
            </div>
        );
    }
}

ShortCourseProgressMap.propTypes = propTypes;
ShortCourseProgressMap.defaultProps = defaultProps;


export default ShortCourseProgressMap;